import { useQuery } from "@tanstack/react-query";
import { NavLink } from "react-router-dom";
import { supabase } from "@/integrations/supabase/client";
import { useAuth } from "@/hooks/useAuth";
import { useCompanyPremiumStatus } from "@/hooks/useCompanyPremiumStatus";

export function CompanyAccountButton() {
  const { user } = useAuth();
  const { data: isPremium } = useCompanyPremiumStatus();
  const { data: company } = useQuery({
    queryKey: ["company-sidebar-account", user?.id],
    queryFn: async () => {
      if (!user?.id) return null;
      const { data } = await supabase
        .from("companies")
        .select("name, logo_url")
        .eq("user_id", user.id)
        .maybeSingle();
      return data;
    },
    enabled: !!user?.id,
  });

  return (
    <NavLink
      to="/bedrijf/account"
      className={({ isActive }) =>
        "flex items-center gap-2 rounded-full pl-1 pr-3 py-1 transition-colors max-w-[220px] " +
        (isActive ? "bg-cyan-light text-cyan-dark" : "hover:bg-muted/60")
      }
    >
      {company?.logo_url ? (
        <img
          src={company.logo_url}
          alt={company?.name || "Bedrijf"}
          className="w-7 h-7 rounded-full object-cover shrink-0 bg-white ring-1 ring-cyan-light"
        />
      ) : (
        <span className="w-7 h-7 rounded-full shrink-0 flex items-center justify-center bg-gradient-to-br from-cyan-light/70 to-cyan-light/30 text-cyan-dark text-[11px] font-black">
          {(company?.name || "A").charAt(0).toUpperCase()}
        </span>
      )}
      <span className="hidden sm:flex min-w-0 flex-col leading-tight text-left">
        <span className="truncate text-xs font-bold">{company?.name || "Account"}</span>
        <span className="truncate text-[10px] font-medium text-muted-foreground">
          {isPremium ? "Premium Partner" : "Gratis account"}
        </span>
      </span>
    </NavLink>
  );
}
